// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__MEpnh","Content":"Footer_Content__-eOUG","Social":"Footer_Social__BxbY8","Yarn":"Footer_Yarn__MXSKy"};